// extracted by mini-css-extract-plugin
module.exports = {"midGrey":"#d1d3d4","cream":"#eae4df"};